import { useState } from 'react'
import { Camera, Paperclip, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface AttachButtonProps {
  onAttachFile: () => void
  onTakePhoto: () => void
  disabled?: boolean
  /** Small round trigger for the assistant panel's composer action row. */
  compact?: boolean
}

export function AttachButton({ onAttachFile, onTakePhoto, disabled = false, compact = false }: AttachButtonProps) {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <div className="relative flex flex-col justify-center">
      {showMenu && (
        <>
          <button
            type="button"
            className="fixed inset-0"
            aria-label="Close attachment menu"
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute bottom-full left-0 z-10 mb-1.5 flex w-40 flex-col overflow-hidden rounded-lg border border-border bg-card shadow-[0_4px_12px_rgba(0,0,0,0.10)]">
            <button
              type="button"
              className="flex cursor-pointer items-center gap-2.5 px-3.5 py-[11px]"
              onClick={() => { setShowMenu(false); onAttachFile() }}
            >
              <Paperclip size={15} className="shrink-0 text-foreground" />
              <span className="text-[14px] text-foreground">Attach file</span>
            </button>
            <div className="h-px bg-muted" />
            <button
              type="button"
              className="flex cursor-pointer items-center gap-2.5 px-3.5 py-[11px]"
              onClick={() => { setShowMenu(false); onTakePhoto() }}
            >
              <Camera size={15} className="shrink-0 text-foreground" />
              <span className="text-[14px] text-foreground">Take photo</span>
            </button>
          </div>
        </>
      )}
      <button
        type="button"
        className={cn(
          compact
            ? 'flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full hover:bg-muted'
            : 'flex h-[60px] w-[60px] shrink-0 cursor-pointer items-center justify-center rounded-[18px] bg-muted',
          disabled && 'opacity-40',
        )}
        onClick={() => setShowMenu(v => !v)}
        disabled={disabled}
        aria-label="Attach"
      >
        <Plus size={compact ? 16 : 18} className={disabled ? 'text-muted-foreground/50' : 'text-muted-foreground'} />
      </button>
    </div>
  )
}
